import { useQuery } from "react-query";
import axios from "axios";

const getTagsForPortfolio = async (portfolioId) => {
  const { data: tags } = await axios.get(
    `/api/v2/portfolios/${portfolioId}/tags`
  );
  return tags;
};
export default function useTagsForPortfolio(portfolioId) {
  return useQuery(["portfolios", portfolioId, "tags"], () => {
    return getTagsForPortfolio(portfolioId);
  });
}
